// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


// This is for Firebase Hosting on cogniture.
const firebaseConfig = {
  apiKey: "AIzaSyA89Jrfsk9lT6ltxp3LKSraoarx0jnSJK0",
  authDomain: "cogniture.firebaseapp.com",
  projectId: "cogniture",
  storageBucket: "cogniture.firebasestorage.app",
  messagingSenderId: "845005268197",
  appId: "1:845005268197:web:37e478f88caf59c873a00c",
  measurementId: "G-SPD86CYFZE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Only initialize analytics if we're in a browser environment and not in an iframe
let analytics = null;
if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.error('Analytics initialization error:', e);
  }
}

const auth = getAuth(app);
export { auth };